import Dexie, { Table } from 'dexie';
import { DomainValue, DomainValues, FormDefinition } from '../../../services/api.service';
import { UserGroup } from '../../users/models/user-group.model';

export interface FormDefinitionEntry {
  _id: string;
  timestamp: number;
  content: FormDefinition;
}

export interface DomainValueEntry {
  _id: string;
  timestamp: number;
  content: DomainValue;
}

export interface DomainValuesEntry {
  _id: string;
  timestamp: number;
  content: DomainValues;
}

export interface EntityEntry {
  code: string;
  timestamp: number;
  content: any;
}

export interface UserEntry {
  username: string;
  timestamp: number;
  content: any;
}

export interface UserGroupEntry {
  groupName: string;
  timestamp: number;
  content: UserGroup;
}

export class ConfigurationDb extends Dexie {
  public formDefinitions!: Table<FormDefinitionEntry>;
  public domainValue!: Table<DomainValueEntry>;
  public domainValues!: Table<DomainValuesEntry>;
  public entities!: Table<EntityEntry>;
  public userGroups!: Table<UserGroupEntry>;
  public users!: Table<UserEntry>;

  constructor() {
    super('configFDM');
    this.version(3).stores({
      formDefinitions: '_id, timestamp',
      domainValue: '_id, timestamp',
      domainValues: '_id, timestamp',
      entities: 'code, timestamp',
      userGroups: 'groupName, timestamp',
      users: 'username, timestamp',
    });
  }
}

export const configurationDb = new ConfigurationDb();
